import { BarChart3, Briefcase, Building2, ClipboardList, Database, FileText, Gavel, Inbox, Landmark, LayoutDashboard, LayoutGrid, LayoutList, LineChart, List, Scale, Table, Users, type LucideIcon } from "lucide-react";

/** Icons a screen may carry in the menu. The Screen Builder offers exactly these, so a menu never waits on a dynamic import. */
export const SCREEN_ICONS: Record<string, LucideIcon> = {
  LayoutDashboard, LayoutGrid, LayoutList, List, Table, FileText, ClipboardList, Inbox, BarChart3, LineChart, Database, Briefcase, Building2, Scale, Landmark, Gavel, Users,
};

export const screenIcon = (name?: string | null): LucideIcon => (name && SCREEN_ICONS[name]) || LayoutGrid;
